import {
  TextInput,
  TextInputProps,
} from "o4a-react";
import * as React from "react";
import { getAddressRange } from "../../helpers/resourceHelper";

export type AddressRangeProps = Pick<TextInputProps,
"className"
| "defaultValue"
| "label"
| "fieldName"
| "groupName"
>

/**
 * The address is passed via defaultValue because
 * SimpleBuilder maps the provided defaults explicitly to the defaultValue prop
 */
export const AddressRange = ({ defaultValue = "", ...textInputProps }: AddressRangeProps) : JSX.Element => {
  const addressRange = getAddressRange(defaultValue);

  return (
    <TextInput
      readOnly
      key={addressRange}
      defaultValue={addressRange}
      {...textInputProps}
    />
  );
};
